import { render, staticRenderFns } from "./ZoomImagen.vue?vue&type=template&id=2e359e9c"
import script from "./ZoomImagen.vue?vue&type=script&lang=js"
export * from "./ZoomImagen.vue?vue&type=script&lang=js"
import style0 from "./ZoomImagen.vue?vue&type=style&index=0&id=2e359e9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports